import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { APP_DEFAULT_LANGUAGE } from "../constants/common";
import arTranslations from "./locales/ar/translation.json";
import enTranslations from "./locales/en/translation.json";

const urlLanguage = window.location.pathname.split("/")[1];
const initialLanguage = urlLanguage === "ar" || urlLanguage === "en" ? urlLanguage : APP_DEFAULT_LANGUAGE;

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslations },
    ar: { translation: arTranslations },
  },
  lng: initialLanguage,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
  debug: false,
});
localStorage.setItem("lang", initialLanguage);

export default i18n;
